import React, { useState } from 'react'
import SignupModal from './SignupModal'

function Header(props) {
  const { group } = props || {}
  const { version } = props || {}
  const [showSignupModal, setShowSignupModal] = useState(false)

  if (group) {
    return (
        <header className="site_header" data-sticky-shrink="false">
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                <a href="/" className="logo_with_group">
                    <img
                      src="/assets/images/HabitCircles/hc_logo.svg"
                      alt="Canvas Logo"
                      className="logo_with_group"
                    />
                </a>
                <h3 className='header_group_name'>{group?.name}</h3>
            </div>
            <div className="header_menu_item">
              <button 
                className="header_menu_item_link signup_btn"
                onClick={() => setShowSignupModal(true)}
                style={{ 
                  background: 'none', 
                  border: 'none', 
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  color: 'inherit',
                  textDecoration: 'none'
                }}
              >
                <img
                    src="/assets/images/shared/waving-hand_emoji.png"
                    className="waving_"
                    width="20"
                    height="20"
                    style={{ marginRight: '10px'}}
                />
                Sign Up
              </button>
            </div>
            {showSignupModal && (
              <SignupModal 
                onClose={() => setShowSignupModal(false)}
                group={group}
                version={version}
              />
            )}
        </header>
    )
  }

  return (
    <header className="site_header" data-sticky-shrink="false">
        <a href="/" className="logo">
            <img
              src="/assets/images/HabitCircles/hc_logo.svg"
              alt="Canvas Logo"
              className="logo"
            />
        </a>
        <div className="header_menu_item">
          <button 
            className="header_menu_item_link signup_btn"
            onClick={() => setShowSignupModal(true)}
            style={{ 
              background: 'none', 
              border: 'none', 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              color: 'inherit',
              textDecoration: 'none'
            }}
          >
              <img
                  src="/assets/images/shared/waving-hand_emoji.png"
                  className="waving_"
                  width="20"
                  height="20"
                  style={{ marginRight: '10px'}}
              />
            Sign Up
          </button>
        </div>
        {showSignupModal && (
          <SignupModal 
            onClose={() => setShowSignupModal(false)}
            group={group}
            version={version}
          />
        )}
    </header>
  )
}

export default Header
